import type { ReactElement } from 'react';

import Head from 'next/head';
import { memo } from 'react';

import { useStaticContext } from '~/utilities/context/static/StaticContext';

// Native iOS Smart App Banner (Safari renders it from this meta tag). Replaces the
// Highstreet-hosted SmartBanner once content disables `smartAppBannerEnabled`.
// The Android equivalent is configured statically in `public/_fes/gstar/manifest.json`
// via `related_applications`.
const NativeAppBannerComponent = (): ReactElement | null => {
  const {
    configuration: { appStoreId },
  } = useStaticContext();

  if (!appStoreId) {
    return null;
  }

  return (
    <Head>
      <meta name="apple-itunes-app" content={`app-id=${appStoreId}`} key="meta-apple-itunes-app" />
    </Head>
  );
};

export const NativeAppBanner = memo(NativeAppBannerComponent);
